export default function batchid(state = '', action) {
  if (action.type === 'batchid') {
    return state = action.id;
  } else {
    return state;
  }
}
